import { createContext, SetStateAction } from "react";
import type { UserClass } from "../../api-client/models/userClass";

type InnerUserContextValue = {
  user?: UserClass;
  chatLoaded: boolean;
  setChatLoaded: (_: SetStateAction<boolean>) => void;
  isLoading: boolean;
};

export const InnerUserContext = createContext<InnerUserContextValue>({
  user: undefined,
  chatLoaded: false,
  setChatLoaded: (_: SetStateAction<boolean>) => {},
  isLoading: true,
});
